"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeSchema = void 0;
exports.themeSchema = {
    defaultSchema: {
        font: {
            header: 'Inter',
            default: 'Inter',
        },
        borderRadius: {
            content: '0.5rem',
            box: 'content',
            button: '0.375rem',
            input: '0.25rem',
            badge: '0.375rem',
            image: '0.375rem',
        },
        fontWeight: {
            normal: '400',
            medium: '500',
            bold: '700',
            semibold: '600',
            header: 'bold',
        },
        boxShadow: {
            content: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
            header: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
            popover: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
            accent: '0 10px 15px -3px rgb(var(--colors-accent-500) / 0.5), 0 4px 6px -4px rgb(var(--colors-accent-500) / 0.5)',
            brand: '0 10px 15px -3px rgb(var(--colors-brand-500) / 0.5), 0 4px 6px -4px rgb(var(--colors-brand-500) / 0.5)',
            hero: '0 20px 50px -12px rgb(var(--colors-brand-500) / 0.5), 0 -4px 15px -4px rgb(var(--colors-brand-500) / 0.5)',
            input: '0 0 0 0 rgb(0 0 0 / 0.0)',
            'button-header': '0 0 0 0 rgb(0 0 0 / 0.0)',
            'button-brand': '0 0 0 0 rgb(0 0 0 / 0.0)',
            'button-default': '0 0 0 0 rgb(0 0 0 / 0.0)',
            'button-alternative': '0 0 0 0 rgb(0 0 0 / 0.0)',
            'tabbar-shadow': '0 -1px 2px 0 rgb(0 0 0 / 0.05)',
        },
        borderWidth: {
            'width-content': '0',
            'width-input': '1px',
            'width-button': '1px',
        },
        colors: {
            body: 'misc-100',
            white: '255 255 255',
            'content-background': 'white',
            'content-background-hover': 'misc-50',
            'content-border': 'transparent',
            'content-separator': 'misc-200',
            'header-background': 'white',
            'header-border': 'misc-100',
            'header-text': 'secondary-500',
            'header-text-hover-active': 'primary-500',
            'header-text-hover': 'primary-500',
            'header-text-active': 'primary-500',
            'footer-background': 'absolute-800',
            'footer-border': 'footer-background',
            'footer-text': 'absolute-300',
            'footer-text-hover': 'absolute-200',
            'footer-text-active': 'footer-text-hover',
            'footer-appname': 'absolute-100',
            'tabbar-background': 'content-background',
            'tabbar-border': 'transparent',
            'button-header-background': 'misc-100',
            'button-header-text': 'primary-500',
            'button-header-border': 'misc-200',
            'button-header-ring': 'misc-200',
            'button-brand-background': 'brand-500',
            'button-brand-text': 'on-brand',
            'button-brand-border': 'button-brand-background',
            'button-brand-ring': 'brand-300',
            // not on prototype latest
            'button-cta-background': 'accent-500',
            'button-cta-text': 'absolute-0',
            'button-cta-border': 'button-cta-background',
            'button-cta-ring': 'accent-300',
            'button-default-background': 'misc-100',
            'button-default-text': 'primary-500',
            'button-default-border': 'misc-200',
            'button-default-ring': 'misc-200',
            'button-alternative-background': 'accent-200',
            'button-alternative-text': 'accent-700',
            'button-alternative-border': 'button-alternative-background',
            'button-alternative-ring': 'accent-300',
            'functionbar-background': 'misc-50',
            'functionbar-border': 'misc-200',
            'tooltip-background': 'primary-500',
            'tooltip-text': 'content-background',
            'input-border-color': 'misc-200',
            'on-brand': 'absolute-0',
            'brand-200': '225 232 255',
            'brand-300': '192 210 255',
            'brand-500': '64 64 255',
            'brand-700': '45 65 166',
            'brand-overlay': 'brand-500',
            'on-accent': 'on-brand',
            'accent-200': 'brand-200',
            'accent-300': 'brand-300',
            'accent-500': 'brand-500',
            'accent-700': 'brand-700',
            'on-primary': 'absolute-0',
            'primary-200': '245 246 250',
            'primary-300': '105 113 130',
            'primary-500': '37 40 46',
            'primary-700': '20 21 25',
            'secondary-200': '245 246 250',
            'secondary-300': '190 197 208',
            'secondary-500': '105 113 130',
            'secondary-700': '37 40 46',
            'danger-200': '245 197 201',
            'danger-500': '199 18 64',
            'danger-700': '159 13 50',
            'warn-200': '254 240 138',
            'warn-500': '255 213 74',
            'warn-700': '133 77 14',
            'success-200': '180 240 202',
            'success-500': '9 133 88',
            'success-700': '10 83 66',
            'info-200': '199 223 252',
            'info-500': '88 155 237',
            'info-700': '10 70 143',
            'misc-50': '248 250 254',
            'misc-100': '245 246 252',
            'misc-200': '228 232 242',
            'misc-300': '190 197 212',
            'absolute-0': '255 255 255',
            'absolute-100': '245 246 250',
            'absolute-200': '228 232 238',
            'absolute-300': '190 197 208',
            'absolute-500': '37 40 46',
            'absolute-700': '20 21 25',
            'absolute-800': '13 17 22',
            'absolute-1000': '0 0 0',
            'various-gray': '115 115 115',
            'various-red': '239 68 68',
            'various-orange': '249 115 22',
            'various-amber': '245 158 11',
            'various-yellow': '234 179 8',
            'various-lime': '132 204 22',
            'various-green': '34 197 94',
            'various-emerald': '16 185 129',
            'various-teal': '20 184 166',
            'various-cyan': '6 182 212',
            'various-sky': '14 165 233',
            'various-blue': '59 130 246',
            'various-indigo': '99 102 241',
            'various-violet': '139 92 246',
            'various-purple': '168 85 247',
            'various-fuchsia': '217 70 239',
            'various-pink': '236 72 153',
            'various-rose': '244 63 94',
            'fill-text': 'primary-500',
            'fill-front': 'accent-500',
            'fill-back': 'accent-300',
            'logo-text': 'primary-500',
            'logo-front': 'accent-500',
            'logo-back': 'accent-300',
            'chart-color-1': 'various-indigo',
            'chart-color-2': 'various-purple',
            'chart-color-3': 'various-sky',
            'chart-color-4': 'various-lime',
            'chart-color-5': 'various-pink',
            'chart-color-6': 'various-cyan',
            'chart-color-7': 'various-teal',
            'chart-color-8': 'various-yellow',
            'chart-color-9': 'various-fuchsia',
            'chart-color-10': 'various-orange',
            'chart-color-11': 'various-red',
            'chart-color-12': 'various-blue',
        },
    },
    dark: {
        fontWeight: {
            normal: '400',
            medium: '500',
            bold: '700',
            semibold: '600',
            header: 'bold',
        },
        boxShadow: {
            content: '0 0 0 0 rgb(0 0 0 / 0.0)',
            hero: '0 0 0 0 rgb(0 0 0 / 0.0)',
            header: '0 none',
            brand: '0 0 0 0 rgb(0 0 0 / 0.0)',
        },
        colors: {
            body: '13 17 22',
            'header-background': 'white',
            'header-border': '13 17 22',
            'button-header-background': 'misc-100',
            'button-header-border': 'misc-100',
            'footer-border': 'misc-300',
            'content-separator': '13 17 22',
            'functionbar-background': 'misc-50',
            'functionbar-border': 'misc-100',
            'brand-overlay': 'brand-500',
            'on-primary': 'absolute-1000',
            'primary-200': '105 113 130',
            'primary-300': '121 129 146',
            'primary-500': '245 246 250',
            'primary-700': '248 251 254',
            'secondary-200': '37 40 46',
            'secondary-300': '105 113 130',
            'secondary-500': '121 129 146',
            'secondary-700': '245 246 250',
            'brand-200': '45 65 166',
            'brand-300': '85 105 206',
            'brand-700': '192 210 255',
            'danger-200': '255 141 141',
            'danger-700': '61 15 15',
            'info-200': '141 218 255',
            'info-700': '12 38 50',
            'warn-200': '255 209 141',
            'warn-700': '69 53 29',
            'success-200': '141 255 189',
            'success-700': '14 53 31',
            'misc-50': '12 16 22',
            'misc-100': '25 28 45',
            'misc-200': '32 35 65',
            'misc-300': '40 43 69',
            white: '18 20 32',
            black: '245 246 250',
            'fill-front': 'brand-500',
            'fill-back': 'brand-700',
        },
    },
};
//# sourceMappingURL=theme-schema.js.map